<!-- <div class="container">
    <div class="popup-container">
      <div class="icon">
        <i class="fa-solid fa-check success-icon"></i>
      </div>
      <h2>Account Created!</h2>
      <p>Your account has been created successfully!<br />Plz verify your Email.</p>
      <div>
        <button (click)="RedirectLogin()" class="ok-btn">Ok</button>
    </div>
    </div>
</div>   -->

<!-- <div class="container">
  <div class="popup-container">
    <div class="icon">
      <i class="fa-solid fa-check success-icon"></i>
    </div>
    <h2>Account Created!</h2>
    <p>Your account has been created successfully!<br />Please verify your Email.</p>
    <p *ngIf="timer > 0">
      You can resend the email in <span>{{ timer }}</span> seconds.
    </p>
    <a
      *ngIf="timer === 0"
      href="javascript:void(0)"
      (click)="resendEmail()"
      class="resend-email"
    >
      Resend Email
    </a>
  </div>
</div>  -->

<!-- Above code is working ok without API binding of Resend Email. -->
@if(!data.isGoogleLogin){
<div class="flex justify-center items-center rounded-lg">
  <div class="popup-container">
    <div class="icon">
      <i class="fa-solid fa-envelope-circle-check success-icon"></i>
    </div>
    <h2>OTP Verification</h2>
    <p>
      Please enter the 6-digit code sent to your email address:<br />
      <span class="email-highlight">{{ email }}</span>
    </p>

    <!-- 6-Digit Verification Code Input -->
    <div class="verification-code-container mt-6">
      <div class="flex justify-center gap-2">
        @for (digit of verificationCode; track $index) {
        <input
          type="text"
          maxlength="1"
          inputmode="numeric"
          pattern="[0-9]*"
          class="digit-input"
          [(ngModel)]="verificationCode[$index]"
          (input)="onDigitInput($event, $index)"
          (keydown)="onKeyDown($event, $index)"
          (paste)="onPaste($event)"
          placeholder="-"
        />
        }
      </div>
    </div>

    <button (click)="verifyCode()" class="verify-btn mt-6">
      Verify Account
    </button>

    <div class="resend-container mt-4">
      <p *ngIf="timer > 0">
        Resend code in <span class="timer-text">{{ timer }}s</span>
      </p>
      <button *ngIf="timer === 0" (click)="resendEmail()" class="resend-btn">
        Resend Code
      </button>
    </div>

    <div class="mt-4">
      <button (click)="redirectToLogin()" class="back-to-login">
        Back to Login
      </button>
    </div>
  </div>
</div>
}@else {
<div class="container">
  <div class="popup-container">
    <div class="icon">
      <i class="fa-solid fa-check-double success-icon"></i>
    </div>
    <h2>Welcome!</h2>
    <p>Your account has been created successfully via Google.</p>
    <button (click)="redirectToLogin()" class="verify-btn mt-6">
      Go to Login
    </button>
  </div>
</div>
}
